import React from 'react'
import EnumSelect from 'components/EnumSelect'
import PropTypes from 'prop-types'
import Ticket from 'model/tickets/ticket'
import { Label } from 'pages/Ticket/styled'
import useTicketUpdate from 'apollo/mutations/Tickets/TICKET_UPDATE'
import { FormItem } from './styled'

const BenefitsQuestionFields = ({ ticket, shouldHighlight }) => {
  const isInProgress = ticket?.state?.isInProgress
  const haveCategory = ticket?.benefit_categories?.length
  const highlightingLogic =
    isInProgress && !haveCategory && shouldHighlight && 'error'

  const { onTicketUpdate } = useTicketUpdate()

  return (
    <>
      <Label required>Benefit Category</Label>
      <FormItem
        name="benefit_categories"
        rules={[
          {
            required: true,
            message: 'Please select a Benefit Category'
          }
        ]}
      >
        <EnumSelect
          status={highlightingLogic}
          showSearch={false}
          showArrow
          onChange={benefit_categories =>
            ticket
              ? onTicketUpdate({
                  id: ticket?.id,
                  attributes: { benefit_categories }
                })
              : undefined
          }
          enum_name="TICKET_BENEFIT_CATEGORY_TYPE"
          mode="multiple"
          placeholder="Select Benefit Category"
          disabled={ticket?.state?.isClosed || ticket?.archived}
        />
      </FormItem>
    </>
  )
}

BenefitsQuestionFields.propTypes = {
  ticket: PropTypes.shape(Ticket.shape).isRequired
}

export default BenefitsQuestionFields
